<app-header [progress]="4" [title]="locale.currentTranslation.personalInformationHeader" data-testid="personal-info-header"></app-header>
<div class="base-content-container" data-testid="personal-info-container">
  <div class="headline3" data-testid="personal-info-title">{{ locale.currentTranslation.personalInformation1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="personal-info-form">
    <div class="" data-testid="surname-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [(value)]="personalInformation.surname"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.witnessSurNamePlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-surname"
            [attr.aria-label]="locale.currentTranslation.witnessSurNamePlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
    <div class="" data-testid="name-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [(value)]="personalInformation.name"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.witnessNamePlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-name"
            [attr.aria-label]="locale.currentTranslation.witnessNamePlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
    <div class="" data-testid="street-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [(value)]="personalInformation.streetAndNumber"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.personalInformationStreetPlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-street"
            [attr.aria-label]="locale.currentTranslation.personalInformationStreetPlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
    <div class="" data-testid="zip-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [type]="'number'"
            [(value)]="personalInformation.zip"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.personalInformationZipPlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-zip"
            [attr.aria-label]="locale.currentTranslation.personalInformationZipPlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
    <div class="" data-testid="city-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [(value)]="personalInformation.city"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.personalInformationCityPlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-city"
            [attr.aria-label]="locale.currentTranslation.personalInformationCityPlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
    <div class="" data-testid="phone-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [type]="'tel'"
            [(value)]="personalInformation.phone"
            (valueChange)="onPhoneChange()"
            [placeholder]="locale.currentTranslation.witnessPhonePlaceholder"
            [showError]="showErrorMessage"
            [required]="true"
            data-testid="input-phone"
            [attr.aria-label]="locale.currentTranslation.witnessPhonePlaceholder"
          ></app-text-input>
        </div>
        @if (incorrectPhoneFormat) {
          <div class="text-body1 error-text" data-testid="phone-format-error" role="alert">{{ locale.currentTranslation.phoneWithCountryCodePlaceholder }}</div>
        }
      }
    </div>
    <div class="" data-testid="email-field">
      @if (personalInformation) {
        <div>
          <app-text-input
            [type]="'email'"
            [(value)]="personalInformation.email"
            (valueChange)="evaluateShowError()"
            [placeholder]="locale.currentTranslation.witnessEmailPlaceholder"
            [showError]="false"
            data-testid="input-email"
            [attr.aria-label]="locale.currentTranslation.witnessEmailPlaceholder"
          ></app-text-input>
        </div>
      }
    </div>
  </div>

  @if (showErrorMessage) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.invalidPhoneNumber }}
    </div>
  }
  <div style="display: flex; flex-direction: column; gap: 8px;" data-testid="contact-preferences">
    <div class="headline4" style="color: #0A1535;" data-testid="contact-preferences-title"> {{ locale.currentTranslation.personalInformation2 }}</div>
    <div class="text-body1" style="display: flex; gap: 8px; justify-content: start; align-items: center;" data-testid="sms-preference">
      <div>
        <input type="checkbox"
               [value]="personalInformation.contactableBySms"
               [formControl]="checkboxControlContactedBySms"
               (change)="updateContactedBySms()"
               data-testid="checkbox-sms"
               [attr.aria-describedby]="'sms-label'"
        >
      </div>
      <div>
        <div id="sms-label" data-testid="sms-label">{{ locale.currentTranslation.personalInformationContactedBySmS }}</div>
      </div>
    </div>
    <div class="text-body1" style="display: flex; gap: 8px; justify-content: start; align-items: center;" data-testid="email-preference">
      <div>
        <input type="checkbox"
               [value]="personalInformation.contactableByEmail"
               [formControl]="checkboxControlContactedByEmail"
               (change)="updateContactedByEmail()"
               data-testid="checkbox-email"
               [attr.aria-describedby]="'email-label'"
        >
      </div>
      <div>
        <div id="email-label" data-testid="email-label">{{ locale.currentTranslation.personalInformationContactedByEmail }}</div>
      </div>
    </div>
  </div>
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="personal-info-footer"></app-footer>
